import { render, staticRenderFns } from "./LocalizationModal.vue?vue&type=template&id=68c9a5d2&scoped=true"
import script from "./LocalizationModal.vue?vue&type=script&lang=js"
export * from "./LocalizationModal.vue?vue&type=script&lang=js"
import style0 from "./LocalizationModal.vue?vue&type=style&index=0&id=68c9a5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c9a5d2",
  null
  
)

export default component.exports